import {
  filtersListToColumnFiltersState,
  mergeFiltersWithQueryParams,
} from '../../utils/tableFilters';
import { useDebouncedEffect } from '@/common/hooks/useDebouncedEffect';
import { FilterTypes } from '@servicepipe/ui-components';
import { Box, ICONS_NAME, Input, SelectSingle, TopFilterWrapper } from '@servicepipe/ui-components';
import React, { useEffect, useMemo, useState } from 'react';

const getFilterOptions = (filter) => (Array.isArray(filter.options) ? filter.options : []);

const getSelectValue = (filter) =>
  getFilterOptions(filter).find((option) => option.value === filter.value) ?? null;

export const TableFiltersBar = ({ filtersConfig, queryFilters, onFiltersChange }) => {
  const filtersFromQuery = useMemo(
    () => mergeFiltersWithQueryParams(filtersConfig, queryFilters),
    [filtersConfig, queryFilters]
  );

  const [filters, setFilters] = useState(filtersFromQuery);

  useEffect(() => {
    const frameId = requestAnimationFrame(() => {
      setFilters((current) =>
        JSON.stringify(current) === JSON.stringify(filtersFromQuery) ? current : filtersFromQuery
      );
    });

    return () => cancelAnimationFrame(frameId);
  }, [filtersFromQuery]);

  useDebouncedEffect(
    () => {
      const nextFilters = filtersListToColumnFiltersState(filters);
      const currentFilters = filtersListToColumnFiltersState(filtersFromQuery);

      if (JSON.stringify(nextFilters) === JSON.stringify(currentFilters)) {
        return;
      }

      onFiltersChange(nextFilters);
    },
    500,
    [filters, filtersFromQuery]
  );

  const updateFilter = (value, name) => {
    setFilters((current) =>
      current.map((filter) => (filter.name === name ? { ...filter, value } : filter))
    );
  };

  return (
    <TopFilterWrapper>
      <Box gap="8px" wrap="wrap">
        {filters.map((filter) => {
          if (filter.type === FilterTypes.SELECT) {
            return (
              <Box key={filter.id} width={filter.width || 'auto'} flexShrink={0}>
                <SelectSingle
                  isClearable
                  size={filter.size || 'medium'}
                  placeholder={filter.label}
                  value={getSelectValue(filter)}
                  options={getFilterOptions(filter)}
                  onChange={(option) => updateFilter(option?.value ?? '', filter.name)}
                />
              </Box>
            );
          }

          return (
            <Box key={filter.id} width={filter.width || '200px'} flexShrink={0}>
              <Input
                size={filter.size || 'medium'}
                leftAdornment={ICONS_NAME.search}
                name={filter.name}
                placeholder={filter.label}
                value={filter.value || ''}
                onChange={(event) => updateFilter(event.currentTarget.value, filter.name)}
              />
            </Box>
          );
        })}
      </Box>
    </TopFilterWrapper>
  );
};
